import React from 'react';
import './CaseItem.css';

import { FaPlus } from 'react-icons/fa';
import { Link } from 'react-router-dom';



const CaseItem = (props) => {  
 
  // Destructuring props
  const { id, image, title, category, popup, caseStudy, className } = props;
 
  return (
    <div className={`case-item ${className}`} key={id}>

      <div className="case-content">
  
        {/* Case Study image */} 
        <img src={image} alt={title} /> 
  
        {/* Case Study Content */} 
        <div className='content'> 

          <div className='text'>

            {/* Case Study Category */}
            <p>{category}</p>

            {/* Link to the individual Case Study Detail Page */}
            <Link
              to={{
                pathname: '/CaseStudies/' + title,
              }}
              state={caseStudy} >
              <h3>{title}</h3> {/* Case Study Title */}
            </Link>

          </div>

          {/* Trigger popup function */}
          <a className='view' onClick={() => {popup(id)}}><FaPlus /></a>  

        </div>

      </div>

    </div>
  ) 

}

export default CaseItem;